import UpdateSupportingFileModalTable from "../../../../supportingFileSections/fields/supportingFileTable/updateSupportingFileModalTable";

export default class UpdateProcedureFileModalTable extends UpdateSupportingFileModalTable {}
